import { cn } from '@kalos/ui';
import { ChevronRight } from 'lucide-react';

/**
 * A note in a phone notes list, on the project record and the service job record alike: its
 * first line, then who, when and what's attached, with one status chip and a chevron. The whole
 * row opens the note. Without `onSelect` it's a plain row, for activity that doesn't open.
 */
export const NoteListRow = ({
  title,
  meta,
  chip,
  chipClassName = 'bg-muted text-foreground',
  onSelect,
  wrapTitle = false,
}: {
  title: string;
  meta: string;
  chip?: string;
  chipClassName?: string;
  onSelect?: () => void;
  /** Activity that doesn't open shows its whole text (up to three lines) instead of one. */
  wrapTitle?: boolean;
}) => {
  const body = (
    <>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span
          className={cn(
            'text-sm font-semibold',
            wrapTitle ? 'line-clamp-3 break-words' : 'truncate',
          )}
        >
          {title}
        </span>
        <span className="text-muted-foreground truncate text-sm">{meta}</span>
      </span>
      {chip && (
        <span
          className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium', chipClassName)}
        >
          {chip}
        </span>
      )}
    </>
  );
  return (
    <li>
      {onSelect ? (
        <button
          type="button"
          className="hover:bg-accent -mx-2 flex w-[calc(100%+1rem)] items-center gap-3 rounded-md px-2 py-3 text-left"
          onClick={onSelect}
        >
          {body}
          <ChevronRight className="text-muted-foreground h-4 w-4 shrink-0" aria-hidden />
        </button>
      ) : (
        <div className="flex items-center gap-3 py-3">{body}</div>
      )}
    </li>
  );
};
